export default __webpack_public_path__ + "static/maltstore-1-31cf49d213cf44a22b5bb063b5462f50.jpg";